/* Rquiere de mixin.js */

var user = {
	data() {
		return {
			objectUser: {
				id: '',
				name: '',
				email: '',
				nick: '',
				email_verified_at: '',
				removable: 1,
				img: '',
				status_id: '',
				remember_token: '',
				created_at: '',
				updated_at: ''
			},
			listUsers: [],
			methodsUser: {
				changePassword: 'user/changePassword',
				resetPassword: 'user/resetPassword',
				create: 'user/register',
				delete: 'user/delete/',
				userGet: 'users',
				update: 'user/update',
				show: 'user/',
			}
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		addListUsers(newUser) {
			this.listUsers.push(newUser)
		},
		changePassword(currentPassword, newPassword) {
			let data = {
				currentPassword: currentPassword.trim(),
				newPassword: newPassword.trim()
			}
			this.$emit('showLockScreen', 'Reseteando contraseña . . .')
			let url = this.getApiBackend + this.methodsUser.changePassword
			console.log(url, data)
			this.axiosActionIS(url, 'PUT', 'changePasswordResult', data)
		},
		changePasswordResult(response) {
			this.changePasswordResultLocal(response)
		},
		changePasswordResultLocal(response) {
			console.log('changePasswordResultLocal no desarrollado', response)
		},
		clearObjectUser() {
			this.objectUser.id = '0'
			this.objectUser.name = ''
			this.objectUser.email = ''
			this.objectUser.nick = ''
			this.email_verified_at = ''
			this.removable = 1
			this.img = ''
			this.status_id = ''
			this.remember_token = ''
			this.created_at = ''
			this.updated_at = ''
		},
		deleteUser(id) {
			this.$emit('showLockScreen', 'Borrando usuario . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsUser.delete + id, 'DELETE', 'resultDeleteUser')
		},
		deleteItemListUsers(id) {
			let index = this.listUsers.map((el) => parseInt(el.id)).indexOf(parseInt(id))
			let userDeleted = this.listUsers.splice(index, 1)
		},
		getAllUsers() {
			this.$emit('showLockScreen', 'Obteniendo lista de usuario . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsUser.userGet, 'GET', 'resultgetAllUsers')
		},
		getPriceListUserResult(response) {
			console.log(response)
		},
		initObjectUser(item) {
			this.objectUser.id = item.id
			this.objectUser.name = item.name
			this.objectUser.email = item.email
			this.objectUser.nick = item.nick
		},
		saveUser() {
			let method = (this.objectUser.id === '0') ? 'POST' : 'PUT'
			this.message.text = ''
			this.$emit('showLockScreen', 'Guardando datos . . .')
			console.log(this.getApiBackend + this.methodsUser.create, this.objectUser)
			if (method == 'POST') {
				this.axiosActionIS(this.getApiBackend + this.methodsUser.create, method, 'resultSaveUserPOST', this.objectUser)
			} else if (method == 'PUT') {
				this.axiosActionIS(this.getApiBackend + this.methodsUser.update, method, 'resultSaveUserPUT', this.objectUser)
			}
		},
		resetPassword(id) {
			let authChangePassword = {
				id: id
			}
			this.$emit('showLockScreen', 'Reseteando contraseña . . .')
			this.axiosActionIS(this.getApiBackend + this.methodsUser.resetPassword, 'PUT', 'resetPasswordResult', authChangePassword)
		},
		resetPasswordResult(response) {
			this.resetPasswordResultLocal(response)
		},
		resetPasswordResultLocal(response) {
			console.log('resetPasswordResultLocal no definido', response)
		},
		resultAxiosLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'changePasswordResult': this.changePasswordResult(response); break;
				case 'resetPasswordResult': this.resetPasswordResult(response); break;
				case 'resultgetAllUsers': this.resultgetAllUsers(response); break;
				case 'resultDeleteUser': this.resultDeleteUser(response); break;
				case 'resultSaveUserPOST': this.resultSaveUser(response, responseLocal); break;
				case 'resultSaveUserPUT': this.resultSaveUser(response, responseLocal); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		resultDeleteUser(response) {
			if (response.data.success) {
				this.deleteItemListUsers(response.data.data)
				this.socketEmit(['DELETE_USER'], response.data.data)
				this.clearObjectUser()
			}
		},
		resultgetAllUsers(response) {
			this.listUsers = response.data.data
		},
		resultSaveUser(response, responseLocal) {
			if (response.data.success) {
				if (responseLocal == 'resultSaveUserPOST') {
					this.addListUsers(response.data.data)
					this.socketEmit(['NEW_USER'], response.data.data)
				} else if (responseLocal == 'resultSaveUserPUT') {
					this.updateItemListUsers(response.data.data)
					this.socketEmit(['UPDATE_USER'], response.data.data)
				}
				this.clearObjectUser()
				console.log('Guardado con exito')
			} else {
				this.setErrorSaveUserLocal(response)
			}
		},
		setErrorSaveUserLocal(response) {
			console.groupCollapsed('Error!!! Resultado de consulta axios, funcion por omision (setErrorSaveUserLocal)')
			console.log(response)
			console.groupEnd()
		},
		setUserOfListUser(index, data) {
			this.listUsers[index].name = data.name
			this.listUsers[index].email = data.email
		},
		updateItemListUsers(data) {
			let index = this.listUsers.map((el) => el.id).indexOf(data.id)
			this.setUserOfListUser(index, data)
		}
	},
};

export default user;